import { Draft } from "src/types/common";

export function standardize<T>(update: T) {
  let property: keyof T;
  for (property in update) {
    if (update[property] === undefined)
      delete update[property];
  }
  return update;
}

export function mergeKeys<T>(primary: T, merge: T) {
  let property: keyof T;
  const merged: T = { ...primary, ...merge };
  for (property in merged) {
    if (merge[property] === undefined)
      delete merged[property];
  }
  return merged;
}

export function merge<T>(primary?: Draft<T>, merge?: Draft<T>, type?: 'add' | 'modify' | 'normal') {
  if (!merge)
    return primary;
  if (!primary)
    return merge;

  //
  if (type === 'modify') {
    const merged = standardize<Draft<T>>(merge);
    return { ...primary, ...merged };
  } else if (type === 'normal') {
    return mergeKeys<Draft<T>>(primary, merge);
  } else {
    throw new Error("Cannot merge with this strategy");
  }
};